var isMobile = false;
var devicesWithPointer = false;

mediaMobile();
mediaTouchDevices();

$('.site-header .site-navigation .dropdown').on('mouseenter', function () {
    if (devicesWithPointer)
    {
        console.info('in');
        clearTimeout(window.myTimeout);
        $('.site-header .site-navigation .dropdown [data-toggle="dropdown"]').dropdown('hide');
        $(this).find('[data-toggle="dropdown"]').dropdown('show');
    }
}).on('mouseleave', function () {
    if (devicesWithPointer) {
        var $this = $(this);
        window.myTimeout = window.setTimeout(function () {
            $this.find('[data-toggle="dropdown"]').dropdown('hide').attr('aria-expanded', false);
        }, 500)

    }
});

$(window).on('resize', function () {
    mediaTouchDevices();
});


$(window).on('resize', function () {
    mediaMobile();
    mediaTouchDevices();
});

// Media Query for mobile this will return true or false
function mediaMobile() {
    if (window.matchMedia('(max-width: 767px)').matches) {
        isMobile = true;
    } else {
        isMobile = false;
    }
}

// Media Query for Touch Devices this will return true or false
function mediaTouchDevices() {
    if (window.matchMedia('(any-hover: none)').matches) {
        devicesWithPointer = false;
    } else {
        devicesWithPointer = true;
    }
}
